import { render, staticRenderFns } from "./ModalItensDoRepasse.vue?vue&type=template&id=6e30cc22&scoped=true"
import script from "./ModalItensDoRepasse.vue?vue&type=script&lang=ts"
export * from "./ModalItensDoRepasse.vue?vue&type=script&lang=ts"
import style0 from "./ModalItensDoRepasse.vue?vue&type=style&index=0&id=6e30cc22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e30cc22",
  null
  
)

export default component.exports